<template>
    <div>
        <v-card elevation="0">
            <v-card-title>
                <v-icon color="#FD49A0">mdi-file-upload</v-icon>&nbsp;Upload CSV
            </v-card-title>
            <v-card-subtitle>
                <v-alert type="warning" outlined prominent dense>
                    It is recommended that this feature is to be only used when the file scan has failed in the command line and an immediate fix cannot be done.<br />
                    Successful upload of the file will OVERRIDE ALL data in a chosen collection.
                </v-alert>
            </v-card-subtitle>
            <v-card-text>
                <v-card outlined>
                    <v-card-text>
                        <v-form ref="fileupload">
                            <v-radio-group v-model="type" row mandatory>
                                <v-radio
                                    label="Fund Balances (Collection financial-analysis)"
                                    value="Fund Balances"
                                ></v-radio>
                            </v-radio-group>
                            <br /><v-divider></v-divider><br />
                            <v-file-input
                                accept=".csv"
                                :label="'Choose ONE CSV file to override '+type"
                                outlined
                                v-model="userFile"
                                :rules="[v => /.csv$/i.test(v.name) || 'Please upload one CSV file!']"
                            ></v-file-input>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#FB6090" :disabled="(userFile == null || userFile == '')" class="white--text" @click="uploadFile" :loading="loading">Upload</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            text: "",
            timeout: 3500,
            snackbarColor: "#B2DFDB",
            type: "Fund Balances",
            userFile: "",
            loading: false
        }
    },
    methods: {
        uploadFile(){
            const that = this;
            if(that.$refs.fileupload.validate()){
                let api= 'https://'+that.host+'/cgi-bin/fin-info-api/api.py';
                that.loading = true;
                const formData = new FormData();
                formData.append("mode", "uploadfundbalancesfile");
                formData.append("fileFundBalances", that.userFile);

                fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function(response){
                    return response.json();
                })
                .then(function (data) {
                    if(data.result.match(/ok/i)){
                        that.setSnackbar("Successful: "+data.message.toString(), "green");
                        that.$refs.fileupload.reset();
                    }else {
                        that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    }

                    that.loading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error occurred : "+err.toString(), "red");
                    that.loading = false;
                })
            }
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.text = msg;
            that.snackbarColor = color;
        },
    }
}
</script>